import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Access';

import { routes } from '../lib/routes';
import { MarkedMenuItem } from '../model/menu-item';
import { AliceApp } from '../model/skill';

import { useMenuItems } from './useMenuItems';

const t = i18n(keyset);

type SharingTab = 'main' | 'users';

export const useSharingPageMenuItems = (aliceApp: AliceApp) => {
    const display: Record<SharingTab, boolean> = {
        main: true,
        users: true,
    };

    const items: Array<MarkedMenuItem<SharingTab>> = [
        {
            tab: 'main',
            path: routes.app.skillPage(false, 'sharing/main', aliceApp.id),
            title: t('menu-links'),
            exact: true,
        },
        {
            tab: 'users',
            path: routes.app.skillPage(false, 'sharing/users', aliceApp.id),
            title: t('menu-users'),
            exact: true,
        },
    ];

    return useMenuItems(display, items);
};
